import { computed, readonly, ref } from 'vue'

const online = ref(typeof navigator === 'undefined' ? true : navigator.onLine)
const offlineSince = ref<number | null>(online.value ? null : Date.now())
let listenersAttached = false

function setOnline(value: boolean): void {
  online.value = value
  offlineSince.value = value ? null : (offlineSince.value ?? Date.now())
}

function attachListeners(): void {
  if (listenersAttached || typeof window === 'undefined') return
  window.addEventListener('online', () => setOnline(true))
  window.addEventListener('offline', () => setOnline(false))
  listenersAttached = true
}

export function useNetworkStatus() {
  attachListeners()

  return {
    isOnline: readonly(online),
    isOffline: computed(() => !online.value),
    offlineSince: readonly(offlineSince),
  }
}
